import { render, staticRenderFns } from "./LearningCommunityAspot.vue?vue&type=template&id=05f6dc26"
import script from "./LearningCommunityAspot.vue?vue&type=script&lang=js"
export * from "./LearningCommunityAspot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports